// This is an overview of all the scopes that we are using in our apps
// Please add description to src/client/js/components/admin/rbac/descriptions.js

export const SHARED_LIBRARY_READ = 'SHARED_LIBRARY_READ';
export const SHARED_LIBRARY_WRITE = 'SHARED_LIBRARY_WRITE';

export const TEAM_LIBRARY_READ = 'TEAM_LIBRARY_READ';
export const TEAM_LIBRARY_WRITE = 'TEAM_LIBRARY_WRITE';

export const TEAM_ARCHIVE_READ = 'TEAM_ARCHIVE_READ';
export const TEAM_ARCHIVE_WRITE = 'TEAM_ARCHIVE_WRITE';

export const PERSONAL_LIBRARY_READ = 'PERSONAL_LIBRARY_READ';
export const PERSONAL_LIBRARY_WRITE = 'PERSONAL_LIBRARY_WRITE';
export const PERSONAL_ARCHIVE_READ = 'PERSONAL_ARCHIVE_READ';
export const PERSONAL_ARCHIVE_WRITE = 'PERSONAL_ARCHIVE_WRITE';

export const WORKSPACE_GENERAL_ACCESS = 'WORKSPACE_GENERAL_ACCESS';
export const WORKSPACE_BILLING_ACCESS = 'WORKSPACE_BILLING_ACCESS';
export const WORKSPACE_APPEARANCE_READ = 'WORKSPACE_APPEARANCE_READ';
export const WORKSPACE_APPEARANCE_WRITE = 'WORKSPACE_APPEARANCE_WRITE';
export const WORKSPACE_SSO_READ = 'WORKSPACE_SSO_READ';
export const WORKSPACE_SSO_WRITE = 'WORKSPACE_SSO_WRITE';
export const WORKSPACE_SCIM_READ = 'WORKSPACE_SCIM_READ';
export const WORKSPACE_SCIM_WRITE = 'WORKSPACE_SCIM_WRITE';
export const WORKSPACE_DATA_RETENTION_READ = 'WORKSPACE_DATA_RETENTION_READ';
export const WORKSPACE_DATA_RETENTION_WRITE = 'WORKSPACE_DATA_RETENTION_WRITE';
export const WORKSPACE_AUDIT_LOG_READ = 'WORKSPACE_AUDIT_LOG_READ';
export const WORKSPACE_SFDC_INTEGRATION = 'WORKSPACE_SFDC_INTEGRATION';
export const WORKSPACE_ZOOM_INTEGRATION_READ =
  'WORKSPACE_ZOOM_INTEGRATION_READ';
export const WORKSPACE_ZOOM_INTEGRATION_WRITE =
  'WORKSPACE_ZOOM_INTEGRATION_WRITE';
export const WORKSPACE_CONTACT_IMPORT_INTEGRATION_READ =
  'WORKSPACE_CONTACT_IMPORT_INTEGRATION_READ';
export const WORKSPACE_CONTACT_IMPORT_INTEGRATION_WRITE =
  'WORKSPACE_CONTACT_IMPORT_INTEGRATION_WRITE';
export const WORKSPACE_GROUP_READ = 'WORKSPACE_GROUP_READ';
export const WORKSPACE_GROUP_WRITE = 'WORKSPACE_GROUP_WRITE';
export const WORKSPACE_CONTENT_PRIVACY_RESTRICTIONS =
  'WORKSPACE_CONTENT_PRIVACY_RESTRICTIONS';
export const WORKSPACE_ENTERPRISE_CONTENT_TRANSFER =
  'WORKSPACE_ENTERPRISE_CONTENT_TRANSFER';
export const WORKSPACE_DOMAIN_USER_REPORTS = 'WORKSPACE_DOMAIN_USER_REPORTS';

export const SUGGESTED_WORKSPACE_SIDEBAR = 'SUGGESTED_WORKSPACE_SIDEBAR';
export const SUGGESTED_WORKSPACE_BANNER = 'SUGGESTED_WORKSPACE_BANNER';
export const SUGGESTED_WORKSPACE_WORKSPACE_SWITCHER =
  'SUGGESTED_WORKSPACE_WORKSPACE_SWITCHER';

export const WORKSPACE_PRIVACY_ACCESS = 'WORKSPACE_PRIVACY_ACCESS';
export const WORKSPACE_PRIVACY_CONTROL = 'WORKSPACE_PRIVACY_CONTROL';
export const WORKSPACE_PRIVACY_PAYWALL = 'WORKSPACE_PRIVACY_PAYWALL';

export const WORKSPACE_DOMAIN_JOIN_MANAGE = 'WORKSPACE_DOMAIN_JOIN_MANAGE';

export const USER_STATE_WRITE = 'USER_STATE_WRITE';

export const PASSWORD_RESET_ACTION = 'PASSWORD_RESET_ACTION';

export const CONTENT_UPLOAD_ACTION_READ = 'CONTENT_UPLOAD_ACTION_READ';
export const CONTENT_UPLOAD_ACTION_WRITE = 'CONTENT_UPLOAD_ACTION_WRITE';

export const INVITE_VIEWER_ACTION = 'INVITE_VIEWER_ACTION';
export const INVITE_ADMIN_ACTION = 'INVITE_ADMIN_ACTION';
export const INVITE_CREATOR_ACTION = 'INVITE_CREATOR_ACTION';
export const INVITE_CREATOR_LITE_ACTION = 'INVITE_CREATOR_LITE_ACTION';
export const RESEND_INVITE_ACTION = 'RESEND_INVITE_ACTION';
export const WORKSPACE_INVITATIONS_CONTROL = 'WORKSPACE_INVITATIONS_CONTROL';

export const ENGAGEMENT_INSIGHTS_PAYWALL = 'ENGAGEMENT_INSIGHTS_PAYWALL';
export const ENGAGEMENT_INSIGHTS_PAYWALL_LITE =
  'ENGAGEMENT_INSIGHTS_PAYWALL_LITE';
export const ENGAGEMENT_INSIGHTS_ACCESS = 'ENGAGEMENT_INSIGHTS_ACCESS';
export const ENGAGEMENT_INSIGHTS_ADMIN_ACCESS =
  'ENGAGEMENT_INSIGHTS_ADMIN_ACCESS';
export const ENGAGEMENT_INSIGHTS_PRIVATE_VIDEOS_ACCESS =
  'ENGAGEMENT_INSIGHTS_PRIVATE_VIDEOS_ACCESS';

export const UNLIMITED_CREATORS = 'UNLIMITED_CREATORS';
export const UNLIMITED_VIEWERS = 'UNLIMITED_VIEWERS';

export const SEARCH_ACCESS = 'SEARCH_ACCESS';
export const LEGACY_SEARCH_ACCESS = 'LEGACY_SEARCH_ACCESS';
export const TRANSCRIPT_SEARCH_ACCESS = 'TRANSCRIPT_SEARCH_ACCESS';

// Video-related scopes
export const VIDEO_TOOLS_ACCESS = 'VIDEO_TOOLS_ACCESS';

export const VIDEO_SHARE_PRIVATE_ACTION = 'VIDEO_SHARE_PRIVATE_ACTION';
export const VIDEO_PASSWORD_PROTECT_ACTION = 'VIDEO_PASSWORD_PROTECT_ACTION';
export const VIDEO_INVITE_PEOPLE_ACTION = 'VIDEO_INVITE_PEOPLE_ACTION';
export const VIDEO_SHARE_WITH_TEAM_ACTION = 'VIDEO_SHARE_WITH_TEAM_ACTION';

export const VIDEO_EDIT_OPTIONS_ACCESS = 'VIDEO_EDIT_OPTIONS_ACCESS';

export const VIDEO_SETTINGS_ACCESS = 'VIDEO_SETTINGS_ACCESS';
export const CUSTOM_BRANDING_ACCESS = 'CUSTOM_BRANDING_ACCESS';

export const VIDEO_CTA_ACCESS = 'VIDEO_CTA_ACCESS';
export const VIDEO_THUMBNAIL_ACCESS = 'VIDEO_THUMBNAIL_ACCESS';

export const VIDEO_RECORD_ACCESS = 'VIDEO_RECORD_ACCESS';
export const VIDEO_GUEST_DELETE_ACCESS = 'VIDEO_GUEST_DELETE_ACCESS';

export const VIDEO_ENHANCED_RECORDER_ACCESS = 'VIDEO_ENHANCED_RECORDER_ACCESS';

export const TRANSCRIPTION_ACCESS = 'TRANSCRIPTION_ACCESS';
export const TRANSCRIPTION_PAYWALL = 'TRANSCRIPTION_PAYWALL';

export const VIDEO_PUBLISH_ACCESS = 'VIDEO_PUBLISH_ACCESS';

// Screenshot-related scopes
export const IMAGE_CAPTURE_ACCESS = 'IMAGE_CAPTURE_ACCESS';
export const IMAGE_ENHANCED_CAPTURE_ACCESS = 'IMAGE_ENHANCED_CAPTURE_ACCESS';

export const IMAGE_TOOLS_ACCESS = 'IMAGE_TOOLS_ACCESS';
export const IMAGE_SHARE_PRIVATE_ACTION = 'IMAGE_SHARE_PRIVATE_ACTION';
export const IMAGE_SHARE_WITH_TEAM_ACTION = 'IMAGE_SHARE_WITH_TEAM_ACTION';
export const IMAGE_PASSWORD_PROTECT_ACTION = 'IMAGE_PASSWORD_PROTECT_ACTION';

export const IMAGE_SETTINGS_ACCESS = 'IMAGE_SETTINGS_ACCESS';
export const IMAGE_CTA_ACCESS = 'IMAGE_CTA_ACCESS';
export const IMAGE_EDIT_OPTIONS_ACCESS = 'IMAGE_EDIT_OPTIONS_ACCESS';

export const CONTENT_LIMIT_BANNER = 'CONTENT_LIMIT_BANNER';
export const CONTENT_LIMIT_MODAL = 'CONTENT_LIMIT_MODAL';
export const RECORDING_TIMER_PAYWALL = 'RECORDING_TIMER_PAYWALL';
export const RECORDING_TIMER_PAYWALL_LITE = 'RECORDING_TIMER_PAYWALL_LITE';
export const BILLING_PAGE_COUNTS = 'BILLING_PAGE_COUNTS';
export const SIDEBAR_BANNER_UPSELL = 'SIDEBAR_BANNER_UPSELL';

// TODO(PLFM-373) Use this scope to secure access against auth via SDK token.
export const SDK_ACCESS_TOKEN_AUTH = 'SDK_ACCESS_TOKEN_AUTH';

export const FAVORITES = 'FAVORITES';
export const WATCH_LATER = 'WATCH_LATER';
// This is a special umbrella scope that controls access a baseline user would expect to have (i.e. settings or user profile).
export const AUTHENTICATED_USER_ACCESS = 'AUTHENTICATED_USER_ACCESS';

export const ACCOUNT_NOTIFICATIONS = 'ACCOUNT_NOTIFICATIONS';
export const HELP_BUBBLE_EDU_LINK = 'HELP_BUBBLE_EDU_LINK';
export const HELP_BUBBLE_CONTACT_SUPPORT = 'HELP_BUBBLE_CONTACT_SUPPORT';

export const AUTOJOIN_SIDEBAR = 'AUTOJOIN_SIDEBAR';

// Control which recorders can be used
export const RECORDER_BROWSER_EXTENSION_ACCESS =
  'RECORDER_BROWSER_EXTENSION_ACCESS';

export default {
  ACCOUNT_NOTIFICATIONS,
  CONTENT_LIMIT_BANNER,
  CONTENT_LIMIT_MODAL,
  SHARED_LIBRARY_READ,
  SHARED_LIBRARY_WRITE,
  TEAM_LIBRARY_READ,
  TEAM_LIBRARY_WRITE,
  TEAM_ARCHIVE_READ,
  TEAM_ARCHIVE_WRITE,
  PERSONAL_LIBRARY_READ,
  PERSONAL_LIBRARY_WRITE,
  PERSONAL_ARCHIVE_READ,
  PERSONAL_ARCHIVE_WRITE,
  WORKSPACE_GENERAL_ACCESS,
  WORKSPACE_BILLING_ACCESS,
  WORKSPACE_APPEARANCE_READ,
  WORKSPACE_APPEARANCE_WRITE,
  WORKSPACE_SSO_READ,
  WORKSPACE_SSO_WRITE,
  WORKSPACE_SCIM_READ,
  WORKSPACE_SCIM_WRITE,
  WORKSPACE_DATA_RETENTION_READ,
  WORKSPACE_DATA_RETENTION_WRITE,
  USER_STATE_WRITE,
  PASSWORD_RESET_ACTION,
  CONTENT_UPLOAD_ACTION_READ,
  CONTENT_UPLOAD_ACTION_WRITE,
  INVITE_VIEWER_ACTION,
  INVITE_ADMIN_ACTION,
  INVITE_CREATOR_ACTION,
  INVITE_CREATOR_LITE_ACTION,
  RESEND_INVITE_ACTION,
  RECORDING_TIMER_PAYWALL,
  RECORDING_TIMER_PAYWALL_LITE,
  RECORDER_BROWSER_EXTENSION_ACCESS,
  SIDEBAR_BANNER_UPSELL,
  SEARCH_ACCESS,
  LEGACY_SEARCH_ACCESS,
  TRANSCRIPT_SEARCH_ACCESS,
  VIDEO_TOOLS_ACCESS,
  VIDEO_GUEST_DELETE_ACCESS,
  VIDEO_SHARE_PRIVATE_ACTION,
  VIDEO_PASSWORD_PROTECT_ACTION,
  VIDEO_INVITE_PEOPLE_ACTION,
  VIDEO_SHARE_WITH_TEAM_ACTION,
  VIDEO_EDIT_OPTIONS_ACCESS,
  VIDEO_SETTINGS_ACCESS,
  CUSTOM_BRANDING_ACCESS,
  VIDEO_CTA_ACCESS,
  VIDEO_THUMBNAIL_ACCESS,
  VIDEO_RECORD_ACCESS,
  VIDEO_ENHANCED_RECORDER_ACCESS,
  ENGAGEMENT_INSIGHTS_PAYWALL,
  ENGAGEMENT_INSIGHTS_ACCESS,
  ENGAGEMENT_INSIGHTS_ADMIN_ACCESS,
  ENGAGEMENT_INSIGHTS_PRIVATE_VIDEOS_ACCESS,
  UNLIMITED_CREATORS,
  UNLIMITED_VIEWERS,
  IMAGE_CAPTURE_ACCESS,
  IMAGE_ENHANCED_CAPTURE_ACCESS,
  IMAGE_TOOLS_ACCESS,
  IMAGE_SHARE_PRIVATE_ACTION,
  IMAGE_SHARE_WITH_TEAM_ACTION,
  IMAGE_PASSWORD_PROTECT_ACTION,
  IMAGE_SETTINGS_ACCESS,
  IMAGE_CTA_ACCESS,
  IMAGE_EDIT_OPTIONS_ACCESS,
  BILLING_PAGE_COUNTS,
  WORKSPACE_PRIVACY_ACCESS,
  WORKSPACE_PRIVACY_CONTROL,
  WORKSPACE_PRIVACY_PAYWALL,
  TRANSCRIPTION_ACCESS,
  WORKSPACE_DOMAIN_JOIN_MANAGE,
  WORKSPACE_INVITATIONS_CONTROL,
  SDK_ACCESS_TOKEN_AUTH,
  FAVORITES,
  WATCH_LATER,
  AUTHENTICATED_USER_ACCESS,
  HELP_BUBBLE_EDU_LINK,
  HELP_BUBBLE_CONTACT_SUPPORT,
  SUGGESTED_WORKSPACE_SIDEBAR,
  SUGGESTED_WORKSPACE_BANNER,
  SUGGESTED_WORKSPACE_WORKSPACE_SWITCHER,
  AUTOJOIN_SIDEBAR,
  WORKSPACE_AUDIT_LOG_READ,
  WORKSPACE_CONTACT_IMPORT_INTEGRATION_READ,
  WORKSPACE_CONTACT_IMPORT_INTEGRATION_WRITE,
  WORKSPACE_SFDC_INTEGRATION,
  WORKSPACE_ZOOM_INTEGRATION_READ,
  WORKSPACE_ZOOM_INTEGRATION_WRITE,
  WORKSPACE_GROUP_READ,
  WORKSPACE_GROUP_WRITE,
  WORKSPACE_CONTENT_PRIVACY_RESTRICTIONS,
  VIDEO_PUBLISH_ACCESS,
  WORKSPACE_ENTERPRISE_CONTENT_TRANSFER,
  WORKSPACE_DOMAIN_USER_REPORTS,
};
